<template>
    <div class="meals-empty">
        <figure>
            <svg-icon icon="icon-no-meals" />
        </figure>

        <span>{{ __("The patient did not upload any meals") }}</span>
    </div>
</template>
<script>
export default {
}
</script>
